<template>
  <v-container class="pa-3">
    <v-row class="pa-0 mb-10" >
      <v-col cols="12" class="pa-0 d-flex align-center">
        <h1 class="mr-3">청구서</h1>
      </v-col>
      <v-col cols="12" class="border-b-darkgrey-2px"></v-col>
      <v-col cols="12" class="pa-0" >
        <v-data-table
          :headers="prod_header"
          :items="mberBillList"
          class="elevation-0"
          :items-per-page="5"
          mobile-breakpoint="0">
          <template v-slot:[`item.reg_dtm`]="{item}">
            <span class="hidden-md-and-down">{{ item.reg_dtm }}</span>
            <span class="hidden-md-and-up">{{ item.mob_reg_dtm }}</span>
          </template>
          <template v-slot:[`item.download`]="{ item }">
            <div> 
              <v-btn class="hidden-xs-only" small @click="pdfDownClicked(item, 'bill')">내려받기</v-btn>
              <v-btn class="hidden-sm-and-up" color="primary" small icon @click="pdfDownClicked(item, 'bill')"><v-icon>mdi-cloud-download</v-icon></v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row class="pa-0 mb-10" >
      <v-col cols="12" class="pa-0 d-flex align-center">
        <h1 class="mr-3">납부확인서</h1>
      </v-col>
      <v-col cols="12" class="border-b-darkgrey-2px"></v-col>
      <v-col cols="12" class="pa-0" >
        <v-data-table
          :headers="pay_header"
          class="elevation-0"
          :items="mberPayList"
          :items-per-page="5"
          mobile-breakpoint="0"
        >
          <template v-slot:[`item.pay_dt`]="{item}">
            <span class="hidden-md-and-down">{{ item.pay_dt }}</span>
            <span class="hidden-md-and-up">{{ item.mob_pay_dt }}</span>
          </template>
          <template v-slot:[`item.download`]="{ item }">
            <div>
              <v-btn class="hidden-xs-only" small @click="pdfDownClicked(item, 'pay')">내려받기</v-btn>
              <v-btn class="hidden-sm-and-up" color="primary" small icon @click="pdfDownClicked(item, 'pay')"><v-icon>mdi-cloud-download</v-icon></v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row class="pa-0 mb-10" >
      <v-col cols="12" class="pa-0 d-flex align-center">
        <h1 class="mr-3">증명서</h1>
      </v-col>
      <v-col cols="12" class="border-b-darkgrey-2px"></v-col>
      <v-col cols="12" class="pa-0" >
        <v-data-table
          :headers="hist_header"
          class="elevation-0"
          :items="mberHistList"
          :items-per-page="5"
          mobile-breakpoint="0"
        >
          <template v-slot:[`item.stus_nm`]="{ item }">
            <div>{{ item.stus_nm }}</div>
          </template>
          <template v-slot:[`item.download`]="{ item }">
            <div>
              <v-btn 
                class="hidden-xs-only" 
                small 
                :disabled='item.stus != "available"' 
                @click="pdfDownClicked(item, item.crtf_form)"
              >내려받기</v-btn>
              <v-btn 
                class="hidden-sm-and-up" 
                color="primary" 
                small 
                icon 
                :disabled='item.stus != "available"' 
                @click="pdfDownClicked(item, item.crtf_form)"
              >
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.download_en`]="{ item }">
            <div>
              <v-btn 
                v-if="item.crtf_form == 'mber'"
                class="hidden-xs-only" 
                small 
                :disabled='item.stus != "available"' 
                @click="pdfDownClicked(item, item.crtf_form + '_en')"
              >내려받기</v-btn>
              <v-btn 
                v-if="item.crtf_form == 'mber'"
                class="hidden-sm-and-up" 
                color="primary" 
                small 
                icon 
                :disabled='item.stus != "available"' 
                @click="pdfDownClicked(item, item.crtf_form + '_en')"
              >
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      prod_header: [
        { text: '번호', value: 'seq', class: 'my-header-style', align: ' d-none d-sm-table-cell'},
        { text: '항목', value: 'prod_type_nm', class: 'my-header-style'},
        { text: '내역', value: 'hist', class: 'my-header-style', align: ' d-none d-sm-table-cell'},
        { text: '금액(원)', value: 'prod_amt_fmt', class: 'my-header-style'},
        { text: '청구일시', value: 'reg_dtm', class: 'my-header-style', align: ' d-none d-sm-table-cell'},
        { text: '국문', value: 'download', class: 'my-header-style'},
      ],
      pay_header: [
        { text: '번호', value: 'seq', class: 'my-header-style' , align: ' d-none d-sm-table-cell'},
        { text: '항목', value: 'prod_type_nm', class: 'my-header-style'},
        { text: '내역', value: 'hist', class: 'my-header-style', align: ' d-none d-sm-table-cell'},
        { text: '금액(원)', value: 'prod_amt_fmt', class: 'my-header-style'},
        { text: '발급일시', value: 'pay_dt', class: 'my-header-style', align: ' d-none d-sm-table-cell'},
        { text: '국문', value: 'download', class: 'my-header-style'},
      ],
      hist_header: [
        { text: '번호', value: 'seq', class: 'my-header-style', align: ' d-none d-sm-table-cell'},
        { text: '상태', value: 'stus_nm', class: 'my-header-style', align: ' d-none d-sm-table-cell'},
        { text: '항목', value: 'crtf_form_nm', class: 'my-header-style'},
        { text: '기간', value: 'period', class: 'my-header-style', align: ' d-none d-sm-table-cell'},
        { text: '국문', value: 'download', class: 'my-header-style'},
        { text: '영문', value: 'download_en', class: 'my-header-style'},
      ],
      mberSno: this.$session.get("mberSno") ? this.$session.get("mberSno") : '',
      mberBillList: [],
      mberPayList: [],
      mberHistList: [],
		
    }
  },
  created() {
    this.getCertificate();
  },
  methods: {
    // mobileFormDt(str){
    //   const date = new Date(str)
    //   const hours = ('0' + date.getHours()).slice(-2)
    //   const minutes = ('0' + date.getMinutes()).slice(-2)
    //   return `${hours}:${minutes}`
    // },  
    getCertificate() {
      const params = new FormData();
      params.append("mber_sno", this.mberSno);

      function mobileFormDt(str) {
        const date = new Date(str)
        const years = (date.getFullYear())
        const months = ((date.getMonth() + 1) < 10 ?  '0' +(date.getMonth() + 1) :'' + (date.getMonth() + 1))
        const dates = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
        return `${years}-${months}-${dates} `
      }

      this.$http.post('/mber/getCertificate', params).then((res) => {

        console.log("res :;;",res.data);
        //청구서
        this.mberBillList = res.data.mberBillList;
        this.mberBillList.forEach((e) => {
          e.prod_amt_fmt = e.prod_amt.toLocaleString('ko-KR');
          e.mob_reg_dtm = mobileFormDt(e.reg_dtm);
        })
        //납부확인서
        this.mberPayList = res.data.mberPayList;
        this.mberPayList.forEach((e) => {
          e.prod_amt_fmt = e.prod_amt.toLocaleString('ko-KR');
          e.mob_pay_dt = mobileFormDt(e.pay_dt);
        })
        //증명서
        this.mberHistList = res.data.mberHistList;
        this.mberHistList.forEach((e) => {
          const bgn_dt = e.bgn_dt ? e.bgn_dt : '';
          let end_dt = e.end_dt;
          if(!end_dt) {
            end_dt = '현재';
          }
          e.period = bgn_dt + ' ~ ' + end_dt;
        })

        
      })
      .catch(function (error) {
          console.log(error);
        }
      );
    },
    pdfDownClicked(item, _crtfForm) {
      console.log("pdfDownClicked > item : ", item);
      
      const params = new FormData();

      // 공통
      params.append("mber_sno", this.mberSno);
      params.append("crtf_form", _crtfForm);
      params.append("doc_no", item.doc_no); 

      // 청구서
      params.append("mber_prod_sno", item.mber_prod_sno); 
      params.append("mber_kind", item.mber_kind); 
      params.append("prod_type", item.prod_type); 

      // 납부확인서
      params.append("bill_sno", item.bill_sno);   // tb_mber_prod.mber_prod_sno / tb_confr_pre_reg.pre_reg_sno
      params.append("confr_sno", item.confr_sno); // tb_confr_pre_reg.confr_sno
      params.append("pay_type", item.prod_type);

      // 증명서
      params.append("hist_sno", item.hist_sno);   // 회원 > 이력관리 화면에서 발급된 회원이력(증명서)의 발급문서번호 업데이트

      this.$http.post('/mber/generateCertificate', params).then((res) => {
        console.log("generateCertificate > res : ", res.data);

        const file = res.data.file;

        // const url = window.URL.createObjectURL(file.file_url);
        const aTag = document.createElement('a');
        aTag.href = file.file_url;
        aTag.download = file.orgnl_file_nm;
        aTag.click();      
      })
      .catch(function (error) {
          console.log(error);
        }
      );
    },//pdfDownClicked end
    // pdfDownClicked(item) {
    //   console.log("pdfDownClicked > item : ", item);
    //   // const url = window.URL.createObjectURL(item.file_url);
    //   const aTag = document.createElement('a');
    //   aTag.href = item.file_url;
    //   aTag.download = item.orgnl_file_nm;
    //   aTag.click();
      
    //   const params = new FormData();
    //   params.append("doc_no", item.doc_no);

    //   this.$http.post('/sub/updateIssueDoc', params).then((res) => {

    //     console.log("res : ",res.data);
        
    //   })
    //   .catch(function (error) {
    //       console.log(error);
    //     }
    //   );
    // },//pdfDownClicked end
  },

}
</script>

<style scoped>


  /* /deep/.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 13px !important;
  } */ 

  .text-start {
    font-size: 13px !important;
    padding: 13px 6px 13px 6px !important;
    height: 100% !important;
  }

</style>